import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

interface TrueImpactDropdownRowProps {
  text: JSX.Element | string | number;
  selected?: boolean;
  onClick: () => unknown;
}

const visibilityHiddenStyle: React.CSSProperties = { visibility: 'hidden' };

const TrueImpactDropdownRow: React.FC<TrueImpactDropdownRowProps> = ({
  text,
  selected,
  onClick,
}) => {
  return (
    <div className="checkbox__wrapper radio-button" onClick={onClick}>
      <FontAwesomeIcon
        icon={faCheck}
        style={selected ? undefined : visibilityHiddenStyle}
      />
      <div>{text}</div>
    </div>
  );
};

export default TrueImpactDropdownRow;
